import { 
    ADD_ORDER_ITEM,
    MODIFY_ORDER_ITEM,
    REMOVE_ORDER_ITEM,
    APPLY_DISCOUNT,
    CLEAR_ORDER,
    CHANGE_ORDER_TYPE,
    CHANGE_TABLE } from "../actionTypes"

const initial = { 
    orderType: null,
    table: null,
    order: []
}

const order = (state = initial, action) => {
    let order

    switch (action.type) {
        case CHANGE_ORDER_TYPE:
            let { orderType } = action

            return {
                ...state,
                orderType
            }

        case CHANGE_TABLE:
            let { table } = action
            return {
                ...state,
                table
            }

        case ADD_ORDER_ITEM:
            order = [...state.order]
            order.push({
                variant: action.variant,
                qty: 1,
                price: action.variant.price,
                item: action.item
            })

            return {
                ...state,
                order
            }

        case MODIFY_ORDER_ITEM:
            order = [...state.order]
            order[action.index] = {
                ...order[action.index],
                qty: action.qty,
                price: action?.price ?? order[action.index]?.price
            }
            
            return {
                ...state,
                order
            }

        case APPLY_DISCOUNT:
            order = [...state.order]
            order[action.index] = {
                ...order[action.index],
                discount: action.discount
            }
            
            return {
                ...state,
                order
            }

        case REMOVE_ORDER_ITEM:
            return {
                ...state,
                order: state.order.filter((_, i) => i !== action.index)
            }

        case CLEAR_ORDER:
            return {
                ...state,
                order: []
            }

        default:
            return state
    }
}

export default order